import { FinchConnectionStatus } from '@zorro/clients';
import { Loader } from '@zorro/design-system/v2/Loader';
import { Center } from '@zorro/web/design-system';
import { useMonolithQuery } from '@zorro/web/ui-utils';

import { FinchConnectionCard } from './FinchConnectionCard';
import { FinchIntroduction } from './FinchIntroduction';

type Props = {
  employerId: string;
};

export const FinchIntegrationManagement = ({ employerId }: Props) => {
  const { data: finchEmployer, isLoading: isLoadingEmployer } =
    useMonolithQuery({
      method: 'finchControllerFindEmployer',
      params: [employerId],
    });

  if (isLoadingEmployer) {
    return (
      <Center>
        <Loader />
      </Center>
    );
  }

  if (
    finchEmployer?.connectionStatus &&
    finchEmployer?.connectionStatus !== FinchConnectionStatus.DISCONNECTED
  ) {
    return <FinchConnectionCard employerId={employerId} />;
  }

  return <FinchIntroduction employerId={employerId} />;
};
